import { render } from "./SelectFrenteLoja.vue?vue&type=template&id=255f1ef7&scoped=true"
import script from "./SelectFrenteLoja.vue?vue&type=script&lang=js"
export * from "./SelectFrenteLoja.vue?vue&type=script&lang=js"

import "./SelectFrenteLoja.vue?vue&type=style&index=0&id=255f1ef7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255f1ef7"]])

export default __exports__